import * as React from 'react'

export const DropdownIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="8"
      height="12"
      viewBox="0 0 8 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M3.46094 9.28906L0.460938 6.28906C0.25 6.07812 0.179688 5.75 0.296875 5.46875C0.414062 5.1875 0.695312 5 1 5H7C7.30469 5 7.5625 5.1875 7.67969 5.46875C7.79688 5.75 7.72656 6.07812 7.51562 6.28906L4.51562 9.28906C4.23438 9.59375 3.74219 9.59375 3.46094 9.28906Z"
        fill="currentColor"
      />
    </svg>
  )
}
